import { ReviewedStatusEnum } from './reviewed-status-enum'

export interface TaskCompletedDetailInterface {
  /**
   * 关联活动任务ID
   */
  activityTaskId?: number | null
  /**
   * 【活动任务-目录任务-任务ID】
   */
  outlineTaskId?: number | null
  /**
   * 【活动任务-目录任务-目录ID】
   */
  outlineId?: number | null
  /**
   * 是否完成该任务
   */
  isCompleted?: boolean | null
  /**
   * 【活动任务-目录任务-视频任务】
   *  - 是否已查看
   */
  isViewed?: boolean | null
  /**
   * 【活动任务-目录任务-视频任务】
   *  - 当前查看目录时间点
   */
  viewedVideoAt?: string | null
  /**
   * 【活动任务-目录任务-测验任务】
   *  - 总得分(发布批阅后的得分)
   */
  score?: string | null
  /**
   * 【活动任务-目录任务-测验任务】
   *  - 总得分(批阅未发布时的得分)
   */
  gainedScore?: string | null
  /**
   * 【活动任务-目录任务-测验任务】
   *  - 题目总分
   */
  fullScore?: string | null
  /**
   * 【活动任务-报名任务-报名选项ID】
   */
  enrollOptionId?: number | null
  /**
   * 【活动任务-测验任务-截屏图片地址】
   */
  quizScreenImg?: string | null
  /**
   * 【活动任务-测验任务-截屏图片时间】
   */
  quizScreenTime?: string | null
  /**
   * 课程-习题批阅状态
   */
  reviewedStatus?: ReviewedStatusEnum
}

export class TaskCompletedDetail implements TaskCompletedDetailInterface {
  /**
   * 关联活动任务ID
   */
  activityTaskId?: number | null
  /**
   * 【活动任务-目录任务-任务ID】
   */
  outlineTaskId?: number | null
  /**
   * 【活动任务-目录任务-目录ID】
   */
  outlineId?: number | null
  /**
   * 是否完成该任务
   */
  isCompleted?: boolean | null
  /**
   * 【活动任务-目录任务-视频任务】
   *  - 是否已查看
   */
  isViewed?: boolean | null
  /**
   * 【活动任务-目录任务-视频任务】
   *  - 当前查看目录时间点
   */
  viewedVideoAt?: string | null
  /**
   * 【活动任务-目录任务-测验任务】
   *  - 总得分(发布批阅后的得分)
   */
  score?: string | null
  /**
   * 【活动任务-目录任务-测验任务】
   *  - 总得分(批阅未发布时的得分)
   */
  gainedScore?: string | null
  /**
   * 【活动任务-目录任务-测验任务】
   *  - 题目总分
   */
  fullScore?: string | null
  /**
   * 【活动任务-报名任务-报名选项ID】
   */
  enrollOptionId?: number | null
  /**
   * 【活动任务-测验任务-截屏图片地址】
   */
  quizScreenImg?: string | null
  /**
   * 【活动任务-测验任务-截屏图片时间】
   */
  quizScreenTime?: string | null
  /**
   * 课程-习题批阅状态
   */
  reviewedStatus?: ReviewedStatusEnum

  constructor(props: TaskCompletedDetailInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      activityTaskId: _activityTaskId,
      outlineTaskId: _outlineTaskId,
      outlineId: _outlineId,
      isCompleted: _isCompleted,
      isViewed: _isViewed,
      viewedVideoAt: _viewedVideoAt,
      score: _score,
      gainedScore: _gainedScore,
      fullScore: _fullScore,
      enrollOptionId: _enrollOptionId,
      quizScreenImg: _quizScreenImg,
      quizScreenTime: _quizScreenTime,
      reviewedStatus: _reviewedStatus,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.activityTaskId = _activityTaskId
    this.outlineTaskId = _outlineTaskId
    this.outlineId = _outlineId
    this.isCompleted = _isCompleted
    this.isViewed = _isViewed
    this.viewedVideoAt = _viewedVideoAt
    this.score = _score
    this.gainedScore = _gainedScore
    this.fullScore = _fullScore
    this.enrollOptionId = _enrollOptionId
    this.quizScreenImg = _quizScreenImg
    this.quizScreenTime = _quizScreenTime
    this.reviewedStatus = _reviewedStatus
  }
}
